import { EventCard } from "./event-card";
import type { RowingEvent } from "@/types";

interface EventListViewProps {
  events: RowingEvent[];
}

export function EventListView({ events }: EventListViewProps) {
  if (events.length === 0) {
    return (
      <p className="py-8 text-center text-gray-500 dark:text-gray-400">
        No events match your filters.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      {events.map((event) => (
        <EventCard key={event.slug} event={event} />
      ))}
    </div>
  );
}
